import { useCallback } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { MagicLinkLoginV5ContentShared } from '@liscio/common';
import { ErrorDialog } from '@liscio/ui';

import { MfaSetupDesktopOnlyInfo } from '../LoginV5View/components';
import {
  LOGIN_SURFACES,
  useTrackLoginEvent,
} from 'analytics/login/useTrackLoginEvent';
import { CpaLoginV5Selector } from 'modules/authenticate/components/CpaLoginV5Selector/CpaLoginV5Selector';
import { useSetLoggedInUserSession } from 'modules/authenticate/hooks';

export const MagicLinkLoginV5View = () => {
  const setLoggedUserSession = useSetLoggedInUserSession();
  const trackLoginEvent = useTrackLoginEvent({
    defaultLoginSurface: LOGIN_SURFACES.MAGIC_LINK_CLICKED,
  });

  const navigate = useNavigate();
  const backToLogin = useCallback(
    () => navigate('/authenticate/login', { replace: true }),
    [navigate]
  );
  const { link } = useParams<{ link: string }>();

  return (
    <MagicLinkLoginV5ContentShared
      token={link || ''}
      isMobile
      backToLogin={backToLogin}
      trackLoginEvent={trackLoginEvent}
      onProcessFinished={async (loggedInUser) => {
        await setLoggedUserSession(loggedInUser);
      }}
      renderCpaSelector={({ cpas, onCancel, onCpaSelected }) => (
        <CpaLoginV5Selector
          onCancel={onCancel}
          cpas={cpas}
          onCpaSelected={onCpaSelected}
        />
      )}
      renderMfaSetupDesktopOnlyInfo={({ getSelectedCpa, resetProcess }) => (
        <MfaSetupDesktopOnlyInfo
          resetProcess={resetProcess}
          getSelectedCpa={getSelectedCpa}
        />
      )}
      renderFallback={({ error, backToLogin }) => (
        <ErrorDialog error={error} onClose={backToLogin} />
      )}
    />
  );
};
